
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import BoardKanban from "./BoardKanban";
import PreviewFile from "./PreviewFile";

export default function FormCongViec() {
    const { user } = useSelector((state) => state.auth);
    const { saveRealTimeData } = useSelector((state) => state.save);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [listMission, setListMission] = useState([]);
    const [listSettings, setListSettings] = useState(null);

    const canEdit = (!id || (detail && detail.author_id == user.data.id)) ? 1 : 0

    const defaultdetail = {
        department_id: id, author_id: user.data.id, title: '', status: 1, list_file: []
    }
    useEffect(() => {
        if (id > 0 && saveRealTimeData && Number(saveRealTimeData.work_id) === Number(id)) {
            if (saveRealTimeData.event_type === "delete_worker_item") {
                const deleteId = saveRealTimeData.item_id || saveRealTimeData.id;
                setListMission((prevList) => prevList.filter(item => Number(item.id) !== Number(deleteId)));
                return;
            }
            if (saveRealTimeData.event_type === "worker_item") {
                console.log(saveRealTimeData.id);
                
                setListMission((prevList) => {
                    const isExisted = prevList.find(item => Number(item.id) === Number(saveRealTimeData.id));
                    if (isExisted) {
                        return prevList.map(item =>
                            Number(item.id) === Number(saveRealTimeData.id)
                                ? { ...item, ...saveRealTimeData }
                                : item
                        );
                    } else {
                        return [saveRealTimeData, ...prevList];
                    }
                });
            }
        }
    }, [saveRealTimeData, id]);

    useEffect(
        function () {
            Axios.get(URL_LIST_ALL + "works_order_settings?type=kanban", user.config).then(async (res) => {
                if (res.data.status === "success") {
                    setListSettings(res.data.data)
                } else console.log(res.data.message);
            }).catch((err) => console.log(err));
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "works_order/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                let detail = res.data.data
                                detail.list_file = detail.list_file && JSON.parse(detail.list_file)
                                setListMission(detail.list_mission)
                                setDetail(detail);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tiêu đề').max(150, "Độ dài không quá 150 ký tự")
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (values.id > 0) {
                Axios.put(URL_LIST_ALL + 'works_order/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật công việc thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'works_order', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)

                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới công việc thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    window.location.href = '/edit-works_order/' + res.data.id
                                }
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const onFinish = () => {

        Axios.put(URL_LIST_ALL + 'works_order/' + id, { status: 2 }, user.config).then(res => {
            setLoading(false);
            setRefresh(!refresh)
            if (res.data.status === "success") {
                confirmAlert({
                    title: 'Thành công',
                    message: 'Bạn hoàn thành công việc thành công',
                    buttons: [{ label: 'OK' }]
                });
            } else {
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
            }
        }).catch(err => console.log(err));
    }

    return (
        <AkkhorLayout idrole="works_order">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/works_order">Quản lý công việc</Link>
                    </li>
                    <li>{id ? 'Công việc' : 'Thêm mới công việc'}</li>
                </ul>
            </div>
            <div className="card height-auto ql-congviec mt-0">
                <div className="card-body">

                    <div className="col-xs-12"></div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <div className="w-100 form-group">
                                    <label>Tiêu đề <span className="text-danger">*</span></label>
                                    <input type="text" placeholder="VD: Cấp tài khoản cho nhân viên mới" disabled={!canEdit} className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                    <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                                </div>
                                <div className="w-100 form-group">
                                    <label>Nội dung chi tiết</label>
                                    <textarea placeholder="Nhập Nội dung chi tiết..." disabled={!canEdit} className="form-control" {...formik.getFieldProps("description")}></textarea>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6">
                                <label>File đính kèm <small style={{ fontSize: 10 }}></small></label>
                                <PreviewFile
                                    itemClass="col-12 col-sm-3 mb-3"
                                    detail={{ list_file: formik.values.list_file }}
                                    onSelect={(newFiles) => {
                                        const updatedFiles = [...formik.values.list_file, ...newFiles];
                                        formik.setFieldValue("list_file", updatedFiles);
                                    }}
                                    onRemove={(indexToRemove) => {
                                        const updatedFiles = formik.values.list_file.filter((_, i) => i !== indexToRemove);
                                        formik.setFieldValue("list_file", updatedFiles);
                                    }}
                                    // 4. Cho phép sửa (hiện nút xóa và nút thêm)
                                    isEdit={canEdit}
                                />
                            </div>
                            {id > 0 &&
                                <div className="w-100 p-2 rounded">
                                    <div className="w-100 d-flex">
                                        <h5 className="w-100 mb-0">Tiến độ công việc {(detail && detail.status == 2) && <span className="text-success">"Công việc đã hoàn thành"</span>}</h5>
                                    </div>
                                    <BoardKanban
                                        listMission={listMission}
                                        listSettings={listSettings}
                                        detail={detail ? detail : null}
                                        onRefresh={() => setRefresh(!refresh)}
                                        user={user}
                                        canEdit={canEdit}
                                    />

                                </div>
                            }
                            {id > 0 ?
                                <>{(detail && detail.author_id == user.data.id && detail.status == 1) ?
                                    <div className="col-12 form-group mt-4">
                                        <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">
                                            {loading ? <Spinner /> : <>Lưu lại</>}
                                        </button>
                                        <button disabled={formik.isSubmitting} className="btn btn-success" onClick={() => {
                                            onFinish()
                                        }}>
                                            {loading ? <Spinner /> : <>Hoàn thành công việc</>}
                                        </button>
                                    </div> :
                                    ""}
                                </>
                                :
                                <div className="col-12 form-group mt-4">
                                    <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">
                                        {loading ? <Spinner /> : <>Lưu lại</>}
                                    </button>
                                    <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
